module.exports = __webpack_public_path__ + "img/binaryf.5962fefc.png";